import { render, staticRenderFns } from "./BKInput.vue?vue&type=template&id=30a29773&scoped=true"
import script from "./BKInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./BKInput.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BKInput.vue?vue&type=style&index=0&id=30a29773&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a29773",
  null
  
)

export default component.exports